<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent pb-1" style="height: 100%; background-color: #fcfcfc">
        <b-row>
            <b-col>
                <div style=" padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <b-col md="3" style="padding: 7px" class="my-auto">
                            <span style="font-weight: bolder">Maßnahmen für BaumNr.: {{tree_number}} </span>
                        </b-col>
                        <b-col>
                          <b-button variant="primary" v-if="canGoBack" v-on:click="goBack" class="px-4 float-right ml-3">Zurück</b-button>

                          <b-button-group style="float: right">
                            <b-button variant="primary" class="px-4" style="border-right: 1px solid lightgray;" v-on:click="gotoTree">Baum
                            </b-button>
                                <b-button variant="primary" class="px-4" style="border-left: 1px solid lightgray; border-right: 1px solid lightgray" v-on:click="gotoControls">Kontrollen
                                </b-button>
                                <b-button variant="dark" disabled class="px-4" style="border-left: 1px solid lightgray;" v-on:click="gotoTree">Maßnahmen</b-button>
                                <b-button variant="primary" class="px-4" style="border-left: 1px solid lightgray;" v-on:click="gotoAppointments">Termine</b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-left: 15px; padding-right: 15px" v-if="items.length !== 0">
            <b-col>
                <md-card>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col>
                                <b-table striped :items="items"
                                         :fields="fields_table"
                                         thead-tr-class="no-border"
                                >
                                    <template v-slot:cell(priority)="row">
                                        <b-row style="margin: 0" v-if="row.item.priority === 3">
                                        <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: red"></div>
                                        <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                            Hoch</p>
                                        </b-row>
                                        <b-row style="margin: 0" v-if="row.item.priority === 1">
                                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: green"></div>
                                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                Niedrig</p>
                                        </b-row>
                                        <b-row style="margin: 0" v-if="row.item.priority === 2">
                                            <div style="height: 1.25rem; width: 1.25rem !important; margin-right: 8px; border-radius: 1.25rem; background: yellow"></div>
                                            <p style="text-overflow: ellipsis; white-space:nowrap; margin-bottom: 0.5rem;">
                                                Mäßig</p>
                                        </b-row>
                                    </template>
                                    <template v-slot:cell(image_url)="row">
                                        <image-icon v-if="row.item.image_url !== ''"
                                                    title="Bilder"
                                                    v-on:click="showImage(row.item.image_url, row.item.id)"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"></image-icon>
                                    </template>
                                    <template v-slot:cell(controls)="data">
                                        <check-icon v-if="data.item.finish_date === null"
                                                    title="Fertigstellen"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"  v-on:click="finishTask(data.item.id)"

                                        >
                                        </check-icon>
                                        <delete-icon
                                                title="Löschen"
                                                class="icon-1_5x ml-2 hoverable-icon" fillColor="#f44336" :size="72"
                                                style="color: #f44336" v-on:click="deleteTask(data.item.id)"
                                        ></delete-icon>
                                        <plan-icon v-if="planable && data.item.is_planned === false && data.item.finish_date === null"
                                                    title="Vergeben"
                                                   class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                   style="color: green" v-on:click="planTask(data.item.id)"
                                        ></plan-icon>
                                        <plan-icon v-if="sendable && data.item.is_planned === false && data.item.finish_date === null"
                                                   title="Versenden"
                                                   class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                   style="color: green" v-on:click="planTask(data.item.id)"
                                        ></plan-icon>
                                    </template>
                                    <template v-slot:cell(open)="data">
                                        <open-icon  v-on:click="openTask(data.item.id)"
                                                    title="Öffnen"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"></open-icon>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>
        <b-row v-if="no_tasks">
            <b-col></b-col>
            <b-col>
                <md-card class="mt-5">
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Keine Maßnahmen gefunden</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        Zu diesem Baum liegen noch keine Maßnahmen vor.
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col></b-col>
        </b-row>
        <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null">
        </CoolLightBox>
        <modal name="text"
               :height="'auto'"
               adaptive>
            <p style="padding-top: 12px; padding-left: 12px; margin-bottom: 0.5rem"><strong>Notiz:</strong></p>
            <p style="padding: 12px">{{text}}</p>
        </modal>

        <b-modal
                centered
                v-model="show_delete"
                title="Maßnahme löschen"
                cancel-title="Abbrechen"
                ok-title="Löschen"
                @ok="onDelete"
                ok-variant="danger"
        >Möchten Sie diese Maßnahme wirklich löschen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>
        <b-modal
                centered
                v-model="show_finish"
                title="Maßnahme fertigstellen"
                cancel-title="Abbrechen"
                ok-title="Fertigstellen"
                @ok="onFinish"

                ok-variant="success"
        >Möchten Sie diese Maßnahme fertigstellen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>

        <b-modal
                centered
                v-model="show_plan"
                title="Maßnahme beplanen"
                cancel-title="Abbrechen"
                ok-title="Zuweisen"
                @ok="onPlan"
                @hide="resetPlanning"
                ok-variant="info"
        >
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Datum:</p>
                    <datetime
                            v-model="taskDate"
                            input-class="form-control"
                            input-style="color: black;"
                            :phrases="datetimeConfig.phrases"
                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                            :min-datetime="datetimeConfig.minTime"
                            placeholder="Datum"
                            style="margin-bottom: 1rem"
                    ></datetime>
                    <p style="margin-bottom: 0.5rem">Mitarbeitergruppe:</p>
                    <b-form-select class="black" plain
                                   :options="taskGroups"
                                   v-model="taskGroup">
                        <template v-slot:first>
                            <b-form-select-option :value="null">-- Gruppe auswählen --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>
        <b-modal
                centered
                v-model="show_send"
                title="Maßnahme versenden"
                cancel-title="Abbrechen"
                ok-title="Versenden"
                @ok="onSend"
                ok-variant="info"
        >
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Möchten Sie diese Maßnahme an BIS-Office übergeben ?</p>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";
    import ImageIcon from 'vue-material-design-icons/Image.vue';
    import TextIcon from 'vue-material-design-icons/CommentText.vue';
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'


    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    import CheckIcon from 'vue-material-design-icons/CheckCircle';
    import PlanIcon from 'vue-material-design-icons/AccountMultipleCheck';
    import OpenIcon from 'vue-material-design-icons/OpenInNew.vue';


    import {DateTime as LuxonDateTime} from 'luxon'

    export default {
        name: "controls",
        components: {
            ImageIcon,
            TextIcon,
            CoolLightBox,
            DeleteIcon,
            CheckIcon,
            PlanIcon,
            OpenIcon
        },
        mounted() {
          this.canGoBack = window.history.length > 1;
          this.tree_number = this.$route.params.id;
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/tree_tasks/'+this.$route.params.id
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
              canGoBack: false,
              no_tasks: false,
                images: [
                    '',
                ],
                index: null,
                text: "",
                loader: undefined,
                fields_table: [
                    {key: "priority", label: "Priorität"},
                    {key: "name", label: "Maßnahme"},
                    {key: "tools", label: "Hilfsmittel", formatter: this.formateTools},
                    {key: "note", label: "Notiz"},
                    {key: "image_url", label: "Bilder"},


                ],
                items: [],
                tree_number: "",
                currentTask: null,
                show_delete: false,
                show_finish: false,
                show_plan: false,
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                taskDate: null,
                taskGroup: null,
                taskGroups: [
                    {text: "Bauhof allgemein", value: "Bauhof allgemein"},
                ],
                planable: true,
                sendable: false,
                show_send: false,
            }
        },
        methods: {
          goBack(){
            this.$router.go(-1);
          },
            openTask(id) {
                this.$router.push("/tasks/task/"+id);
            },
            gotoTree() {
                this.$router.push({ path: `/tree/show/${this.$route.params.id}` })
            },
          gotoAppointments() {
            this.$router.push({ path: `/tree/appointments/${this.$route.params.id}` })
          },
            gotoControls() {
                this.$router.push({ path: `/tree/controls/${this.$route.params.id}` })
            },
            showImage(image, taskId) {
                let imgs = image.split("||");
                this.images = [];
                for (let i = 0; i < imgs.length; i++) {
                    if (imgs[i] !== "") {
                        this.images.push(Server_URL + '/baumkontrolle/task/image' + "?task_id=" + taskId + "&image_name=" + imgs[i]+"_x2.jpeg");
                    }
                }
                this.index = 0;
            },
            showText(text) {
                this.text = text;
                this.$modal.show('text');
            },
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.tree_number = response.data.tree_number;
                    this.planable = response.data.planable;
                    this.sendable = response.data.sendable;
                    if (this.planable) {
                        this.fields_table.push(
                            {key: "is_planned", label: "Beplant", formatter: this.formateBool},
                            {key: "create_date", label: "Datum", formatter: this.dateFormater},
                            {key: "finish_date", label: "Erledigt", formatter: this.dateFormater},
                            {key: "controls", label: ""},
                            {key: "open", label: ""})
                    } else if (this.sendable) {
                        this.fields_table.push(
                            {key: "is_planned", label: "Versendet", formatter: this.formateBool},
                            {key: "create_date", label: "Datum", formatter: this.dateFormater},
                            {key: "finish_date", label: "Erledigt", formatter: this.dateFormater},
                            {key: "controls", label: ""},
                            {key: "open", label: ""})
                    } else {
                        this.fields_table.push(
                            {key: "create_date", label: "Datum", formatter: this.dateFormater},
                            {key: "finish_date", label: "Erledigt", formatter: this.dateFormater},
                            {key: "controls", label: ""},
                            {key: "open", label: ""})
                    }

                    this.items = response.data.tasks;
                    if (this.items.length === 0) {
                        this.no_tasks = true;
                    } else {
                        this.tree_number = this.items[0].tree_number;
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkReload(response) {
                if (response.status === 200) {
                    this.$http.get(
                        Server_URL + '/baumkontrolle/tree_tasks/'+this.$route.params.id
                    ).then(this.responseOkGet, this.responseError)
                } else {
                    console.log(response);
                }
            },
            formateTools(value) {
                if (value === null || value === "") {
                    return ""
                }
                let res = value.split("||")
                let ret = res[0]
                for (let i = 1; i < res.length; i++) {
                    if (res[i] !== "") {
                        ret += ", " + res[i];
                    }
                }
                return ret;

            },
            formateBool(value) {
                if (value === true) {
                    return "Ja"
                }  else {
                    return "Nein"
                }
            },
            dateFormater(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },

            deleteTask(id) {
                this.currentTask = id;
                this.show_delete = true;
            },
            onDelete() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.delete(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkReload, this.responseError);
                    this.currentTask = null;
                }
            },

            finishTask(id) {
                this.currentTask = id;
                this.show_finish = true;
            },
            onFinish() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.patch(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkReload, this.responseError);
                    this.currentTask = null;
                }
            },

            planTask(id) {
                if (this.planable) {
                    this.currentTask = id;
                    this.show_plan = true;
                } else if (this.sendable) {
                    this.currentTask = id;
                    this.show_send = true;
                }
            },
            onPlan(event) {
                if (this.taskDate === null || this.taskDate === "" || this.taskGroup === null) {
                    event.preventDefault();
                    this.$bvToast.toast(`Bitte wählen Sie ein Datum UND eine Mitarbeitergruppe aus.`, {
                        title: 'Speichern nicht möglich',
                        autoHideDelay: 3000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                    });
                    return;
                }
                if (this.currentTask !== null) {
                    console.log("todo")
                }
            },
            onSend(event) {
                if (this.currentTask !== null) {
                    this.showLoader();
                    let req = {
                        task: this.currentTask,
                        plan_for: "BIS-OFFICE",
                        date: new Date()
                    };
                    this.$http.post(
                        Server_URL + '/baumkontrolle/task/plan', req
                    ).then(this.responseOkReload, this.responseError);
                }
            },
            resetPlanning() {
                this.currentTask = null;
                this.taskGroup = null;
                this.taskDate = null;
            },
        }
    }
</script>
<style>
    .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgb(66, 139, 202);
    }

    .black {
        color: #000;
    }

    .modal-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .modal-container {
        display: inline-block;
        width: auto;
    }
    .no-border th {
        border-top: none;
    }
</style>
<style scoped>

    .hoverable:hover {
        color: #23282c;
        background-color: rgba(0, 0, 0, 0.075);
        cursor: pointer;
    }

    .hoverable-icon:hover {
        cursor: pointer;
    }
</style>
